import type { Lesson } from './types.js';

// =============================================================================
// SECTION 2 — Explorer (A2). Themes: LOTR, Star Wars, Naruto, Sherlock,
// Indiana Jones, Breaking Bad, Stranger Things.
// =============================================================================

export const U6_LESSONS: Lesson[] = [
  {
    id: 'u6-l1',
    title: 'Simple past — regular',
    popCulture: 'The Lord of the Rings',
    xpReward: 20,
    exercises: [
      {
        id: 'u6-l1-e1',
        type: 'multiple_choice',
        prompt: 'Frodo ___ to Mordor. (walk)',
        choices: ['walked', 'walks', 'walking', 'walk'],
        answerIndex: 0,
        newWord: 'walked',
      },
      {
        id: 'u6-l1-e2',
        type: 'reorder',
        prompt: 'Build: "Sam cooked potatoes last night."',
        tokens: ['Sam', 'cooked', 'potatoes', 'last', 'night', '.'],
        answer: ['Sam', 'cooked', 'potatoes', 'last', 'night', '.'],
      },
      {
        id: 'u6-l1-e3',
        type: 'fill_blank',
        prompt: 'Gollum ___ the ring. (want)',
        answer: 'wanted',
      },
      {
        id: 'u6-l1-e4',
        type: 'translate',
        prompt: 'Translate: "She watched the sunset."',
        from: 'en',
        to: 'pt',
        answer: 'Ela assistiu ao pôr do sol.',
        accepts: ['Ela viu o pôr do sol.'],
      },
      {
        id: 'u6-l1-e5',
        type: 'listen',
        prompt: 'Type what you hear.',
        audioText: 'They travelled for many days.',
        answer: 'They travelled for many days.',
      },
    ],
  },
  {
    id: 'u6-l2',
    title: 'Simple past — irregular',
    popCulture: 'Star Wars',
    xpReward: 25,
    exercises: [
      {
        id: 'u6-l2-e1',
        type: 'multiple_choice',
        prompt: 'Luke ___ his father. (meet)',
        choices: ['met', 'meeted', 'meet', 'meeting'],
        answerIndex: 0,
        newWord: 'met',
      },
      {
        id: 'u6-l2-e2',
        type: 'match_pairs',
        prompt: 'Match present → past.',
        pairs: [
          { left: 'go', right: 'went' },
          { left: 'see', right: 'saw' },
          { left: 'take', right: 'took' },
          { left: 'fly', right: 'flew' },
        ],
      },
      {
        id: 'u6-l2-e3',
        type: 'fill_blank',
        prompt: 'Han Solo ___ the Millennium Falcon. (fly)',
        answer: 'flew',
      },
      {
        id: 'u6-l2-e4',
        type: 'reorder',
        prompt: 'Build: "Yoda spoke in a strange way."',
        tokens: ['Yoda', 'spoke', 'in', 'a', 'strange', 'way', '.'],
        answer: ['Yoda', 'spoke', 'in', 'a', 'strange', 'way', '.'],
      },
      {
        id: 'u6-l2-e5',
        type: 'translate',
        prompt: 'Translate: "Leia foi corajosa."',
        from: 'pt',
        to: 'en',
        answer: 'Leia was brave.',
      },
    ],
  },
];

export const U7_LESSONS: Lesson[] = [
  {
    id: 'u7-l1',
    title: 'Hobbies',
    popCulture: 'Naruto',
    xpReward: 20,
    exercises: [
      {
        id: 'u7-l1-e1',
        type: 'multiple_choice',
        prompt: 'Rock Lee likes to ___.',
        choices: ['train', 'sing', 'cook', 'paint'],
        answerIndex: 0,
        newWord: 'train',
      },
      {
        id: 'u7-l1-e2',
        type: 'match_pairs',
        prompt: 'Match hobbies.',
        pairs: [
          { left: 'Reading', right: 'Ler' },
          { left: 'Singing', right: 'Cantar' },
          { left: 'Training', right: 'Treinar' },
          { left: 'Cooking', right: 'Cozinhar' },
        ],
      },
      {
        id: 'u7-l1-e3',
        type: 'translate',
        prompt: 'Translate: "Eu gosto de ler mangá."',
        from: 'pt',
        to: 'en',
        answer: 'I like reading manga.',
        accepts: ['I like to read manga.'],
      },
      {
        id: 'u7-l1-e4',
        type: 'fill_blank',
        prompt: 'Naruto loves ___ ramen. (eat)',
        answer: 'eating',
      },
    ],
  },
  {
    id: 'u7-l2',
    title: 'Questions — do / does',
    popCulture: 'Sherlock',
    xpReward: 25,
    exercises: [
      {
        id: 'u7-l2-e1',
        type: 'multiple_choice',
        prompt: 'Sherlock asks: "___ you know John?"',
        choices: ['Do', 'Does', 'Did', 'Are'],
        answerIndex: 0,
        newWord: 'Do',
      },
      {
        id: 'u7-l2-e2',
        type: 'reorder',
        prompt: 'Build: "Where do you live?"',
        tokens: ['Where', 'do', 'you', 'live', '?'],
        answer: ['Where', 'do', 'you', 'live', '?'],
      },
      {
        id: 'u7-l2-e3',
        type: 'fill_blank',
        prompt: '"___ Watson drink tea?"',
        answer: 'Does',
      },
      {
        id: 'u7-l2-e4',
        type: 'translate',
        prompt: 'Translate: "Você fala inglês?"',
        from: 'pt',
        to: 'en',
        answer: 'Do you speak English?',
      },
    ],
  },
];

export const U8_LESSONS: Lesson[] = [
  {
    id: 'u8-l1',
    title: 'At the airport',
    popCulture: 'Indiana Jones',
    xpReward: 25,
    exercises: [
      {
        id: 'u8-l1-e1',
        type: 'multiple_choice',
        prompt: 'Indy needs his ___ to travel.',
        choices: ['passport', 'hat', 'whip', 'map'],
        answerIndex: 0,
        newWord: 'passport',
      },
      {
        id: 'u8-l1-e2',
        type: 'match_pairs',
        prompt: 'Match travel words.',
        pairs: [
          { left: 'Flight', right: 'Voo' },
          { left: 'Ticket', right: 'Passagem' },
          { left: 'Luggage', right: 'Bagagem' },
          { left: 'Gate', right: 'Portão' },
        ],
      },
      {
        id: 'u8-l1-e3',
        type: 'reorder',
        prompt: 'Build: "My flight leaves at nine."',
        tokens: ['My', 'flight', 'leaves', 'at', 'nine', '.'],
        answer: ['My', 'flight', 'leaves', 'at', 'nine', '.'],
      },
      {
        id: 'u8-l1-e4',
        type: 'translate',
        prompt: 'Translate: "Onde é o portão 12?"',
        from: 'pt',
        to: 'en',
        answer: 'Where is gate 12?',
      },
      {
        id: 'u8-l1-e5',
        type: 'speak',
        prompt: 'Ask for help at the airport.',
        target: 'Excuse me, where is the boarding gate?',
      },
    ],
  },
];

export const U9_LESSONS: Lesson[] = [
  {
    id: 'u9-l1',
    title: 'Shopping',
    popCulture: 'Breaking Bad',
    xpReward: 25,
    exercises: [
      {
        id: 'u9-l1-e1',
        type: 'multiple_choice',
        prompt: '"How ___ is this?" (preço)',
        choices: ['much', 'many', 'long', 'old'],
        answerIndex: 0,
        newWord: 'much',
      },
      {
        id: 'u9-l1-e2',
        type: 'fill_blank',
        prompt: 'Walter asks: "How ___ barrels are there?" (contáveis)',
        answer: 'many',
      },
      {
        id: 'u9-l1-e3',
        type: 'reorder',
        prompt: 'Build: "I would like two sandwiches."',
        tokens: ['I', 'would', 'like', 'two', 'sandwiches', '.'],
        answer: ['I', 'would', 'like', 'two', 'sandwiches', '.'],
      },
      {
        id: 'u9-l1-e4',
        type: 'translate',
        prompt: 'Translate: "Eu gostaria de pagar."',
        from: 'pt',
        to: 'en',
        answer: 'I would like to pay.',
        accepts: ['I\'d like to pay.'],
      },
    ],
  },
];

export const U10_LESSONS: Lesson[] = [
  {
    id: 'u10-l1',
    title: 'Past continuous',
    popCulture: 'Stranger Things',
    xpReward: 30,
    exercises: [
      {
        id: 'u10-l1-e1',
        type: 'multiple_choice',
        prompt: '"Eleven ___ playing when the demogorgon appeared."',
        choices: ['was', 'is', 'were', 'be'],
        answerIndex: 0,
        newWord: 'was playing',
      },
      {
        id: 'u10-l1-e2',
        type: 'reorder',
        prompt: 'Build: "They were riding their bikes."',
        tokens: ['They', 'were', 'riding', 'their', 'bikes', '.'],
        answer: ['They', 'were', 'riding', 'their', 'bikes', '.'],
      },
      {
        id: 'u10-l1-e3',
        type: 'fill_blank',
        prompt: 'Mike ___ (watch) TV when Will disappeared.',
        answer: 'was watching',
      },
      {
        id: 'u10-l1-e4',
        type: 'translate',
        prompt: 'Translate: "Estávamos estudando quando aconteceu."',
        from: 'pt',
        to: 'en',
        answer: 'We were studying when it happened.',
      },
    ],
  },
];
